import { render, staticRenderFns } from "./PopSelectItem.vue?vue&type=template&id=434a34c8&scoped=true&"
import script from "./PopSelectItem.vue?vue&type=script&lang=js&"
export * from "./PopSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./PopSelectItem.vue?vue&type=style&index=0&id=434a34c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a34c8",
  null
  
)

export default component.exports